import React from 'react';
import { PlayerView as BasePlayerView } from '@zattoo/playback-sdk-react-native';
export const PlayerView = (props) => {
    // @ts-expect-error event module key mismatch
    return React.createElement(BasePlayerView, { ...props });
};
